import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Breadcrumbs from "../../../shared/components/Breadcrumbs";
import ListView from "../../../shared/components/listview/ListView";
import { COMPGROUP, CREATE, EDIT } from "../../../shared/constants/Constants";
import DefaultButton from "../../../shared/components/DefaultButton";
import { CREATENEW } from "../../../shared/constants/Constants";
import { loadCompGroupAddDataRequest, loadCompGroupDataRequest, loadCompGroupDeleteDataRequest, loadCompGroupUpdateDataRequest } from "../redux/Actions";
import Modalpopup from "../../../shared/components/Modalpopup";
import Permissions from "../../../shared/components/Permissions";
import CompGroupForm from "./CompGroupForm";
import FormError from "../../../shared/components/FormError";
import DeleteModal from "../../../shared/components/DeleteModal";

const CommisionCompGroup = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [shouldCloseModal, setShouldCloseModal] = useState(false);
  const [shouldReload, setShouldReload] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  let dispatch = useDispatch();

  let { compgroups, loading, error } = useSelector((state) => state.compgroup);

  useEffect(() => {
    dispatch(loadCompGroupDataRequest());
  }, [dispatch]);

  let emp_no = JSON.parse(localStorage.getItem("emp_no"));
  let module_name = "Commission Comp Group";
  let permission = Permissions(emp_no, module_name);
  let actionsPermission = !(permission.write_permission || permission.delete_permission);

  let tableColumns = [
    {
      display_name: "id",
      field: "id",
      type: "number",
      hide: true
    },
    {
      display_name: "Commission Comp Group Name",
      field: "commission_comp_group_name",
      type: "text",
    },
    {
      field: "actions",
      type: "actions",
      hide: actionsPermission
    }
  ];

  //Send Requests
  function handleAdd(values) {
    delete values.id;
    dispatch(loadCompGroupAddDataRequest(values));
    setShouldCloseModal(true);
  }
  function handleEdit(values) {
    dispatch(loadCompGroupUpdateDataRequest(values))
    setShouldCloseModal(true)
  }
  const handleDelete = () => {
    let deleteRequest = { id: [selectedRow] };
    dispatch(loadCompGroupDeleteDataRequest(deleteRequest));
    setShouldCloseModal(true)
  };

  //close Modals
  const closeAddModal = () => {
    setShowAddModal(false);
    setErrorMessage(null);
  }
  const closeEditModal = () => {
    setShowEditModal(false);
    setErrorMessage(false);
  }
  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  }


  //Attempt to close modal if no errors
  useEffect(() => {
    if (shouldCloseModal && !loading) {
      if (!error) {
        closeAddModal();
        closeEditModal();
        closeDeleteModal();
        setShouldReload(true);
      } else {
        setErrorMessage(error?.msg?.toString());
      }
      setShouldCloseModal(false)
    }
  }, [loading, error, shouldCloseModal])

  //Reload page after request processed
  useEffect(() => {
    if (shouldReload && !loading) {
      dispatch(loadCompGroupDataRequest());
      setShouldReload(false)
    }
  }, [loading, shouldReload])

  //Set action buttons
  let [clickEditFunc, setClickEditFunc] = useState(null);
  let [clickDeleteFunc, setClickDeleteFunc] = useState(null);
  useEffect(() => {
    if (permission.write_permission) {
      setClickEditFunc(
        () => (row) => {
          setSelectedRow(row);
          setShowEditModal(true);
        }
      )
    }
    if (permission.delete_permission) {
      setClickDeleteFunc(
        () => (id) => {
          setSelectedRow(id);
          setShowDeleteModal(true);
        })
    }
  }, [permission])

  return (
    <>
      <Row>
        <Col className="gx-0">
          <Breadcrumbs
            children={[
              { href: '/', label: COMPGROUP },
            ]}
          />
        </Col>
        <Col xs="auto" className="gx-0">
          {permission.create_permission ? (
            <DefaultButton
              buttonClass="default-btn-color"
              buttonTitle={CREATENEW}
              actionBlock={() => setShowAddModal(true)}
            />
          ) : (<></>)}
        </Col>
      </Row>
      <Row>
        <Card>
          <Card.Body>
            <ListView
              exportTitle={COMPGROUP}
              columnNames={tableColumns}
              rowData={compgroups}
              shouldSetNextPrevIds
              clickEdit={clickEditFunc}
              clickDelete={clickDeleteFunc}
            />
          </Card.Body>
        </Card>
      </Row>
      <Modalpopup
        show={showAddModal}
        handleClose={closeAddModal}
        actionTitle={CREATE + COMPGROUP}
      >
        <FormError>
          {errorMessage}
        </FormError>
        <CompGroupForm submit={handleAdd} cancel={closeAddModal} />
      </Modalpopup>
      <Modalpopup
        show={showEditModal}
        handleClose={closeEditModal}
        actionTitle={EDIT + COMPGROUP}
      >
        <FormError>
          {errorMessage}
        </FormError>
        <CompGroupForm compgroup={selectedRow} submit={handleEdit} cancel={closeEditModal} />
      </Modalpopup>
      <DeleteModal show={showDeleteModal} handleDelete={handleDelete} handleClose={closeDeleteModal} />
    </>
  );
};

export default CommisionCompGroup;
